// Styling for the calendar-link settings (bead hf-7o6).
//
// Design tokens only, and a plain stack. This surface is somebody deciding what a
// third party gets to read about their week, so it is laid out to be read slowly:
// generous spacing between the two destructive controls, and no visual emphasis
// competing with the sentences that say what each one does.
//
// The two dangerous buttons are deliberately NOT side by side. A row of two buttons
// invites a glance-and-tap; a stack with its consequence sentence directly above each
// one does not.

export const calendarFeedStylesheet = String.raw`
  .feed-settings {
    display: grid;
    gap: var(--herefor-space-5);
    max-inline-size: 42rem;
  }

  .feed-settings__lede,
  .feed-settings__state,
  .feed-settings__liveness,
  .feed-settings__hint {
    margin: 0;
  }

  .feed-settings__hint {
    color: var(--herefor-color-ink-muted);
    font-size: var(--herefor-font-size-sm);
  }

  .feed-settings__live {
    display: grid;
    gap: var(--herefor-space-4);
  }

  .feed-settings__state {
    font-weight: var(--herefor-font-weight-semibold);
  }

  .feed-settings__detail {
    display: grid;
    gap: var(--herefor-space-2);
    margin: 0;
    padding: var(--herefor-space-4);
    border: 1px solid var(--herefor-color-border);
    border-radius: var(--herefor-radius-md);
  }

  .feed-settings__choice {
    display: flex;
    gap: var(--herefor-space-2);
    align-items: center;
    /* A tap target a thumb can hit without hitting the other one. */
    min-block-size: var(--herefor-target-size-min);
  }

  /* Each destructive control sits under its own consequence sentence, with room
     between the pairs so they cannot be mistaken for one group of buttons. */
  .feed-settings__actions {
    display: grid;
    gap: var(--herefor-space-3);
    justify-items: start;
  }

  .feed-settings__actions > .feed-settings__hint:not(:first-child) {
    margin-block-start: var(--herefor-space-4);
  }

  .feed-settings__outcome {
    display: grid;
    gap: var(--herefor-space-4);
  }

  .feed-settings__lines {
    display: grid;
    gap: var(--herefor-space-3);
    justify-items: start;
  }

  .feed-settings__lines p {
    margin: 0;
  }

  .feed-settings__outcome-title {
    font-size: var(--herefor-font-size-lg);
    font-weight: var(--herefor-font-weight-semibold);
    line-height: var(--herefor-line-height-tight);
  }
`;
